import { FormHelperText } from '@mui/material';
import { useFormContext, useFormState, useWatch } from 'react-hook-form';
import { DateTime } from 'luxon';

import { useCommonTranslation } from '@/hooks/useCommonTranslation';
import type { ReservationFormInput } from '../schema/reservationForm.schema';

export function ReturnDateMismatchMessage({ index }: { index: number }) {
  const t = useCommonTranslation();
  const { control } = useFormContext<ReservationFormInput>();

  const roundTripWillCall = useWatch({
    control,
    name: `trips.${index}.roundTripWillCall`,
  });
  const appointmentDateTime = useWatch({
    control,
    name: `trips.${index}.appointmentDateTime`,
  }) as DateTime | null | undefined;
  const returnDateTime = useWatch({
    control,
    name: `trips.${index}.roundTripReturnDateTime`,
  }) as DateTime | null | undefined;
  // The field itself already shows this same text as its own (blocking)
  // error when return is out of range — avoid rendering it a second time.
  const { errors } = useFormState({
    control,
    name: `trips.${index}.roundTripReturnDateTime`,
  });
  const hasFieldError = Boolean(errors.trips?.[index]?.roundTripReturnDateTime);

  if (roundTripWillCall) return null;
  if (!appointmentDateTime?.isValid || !returnDateTime?.isValid) return null;
  if (returnDateTime.hasSame(appointmentDateTime, 'day')) return null;
  if (hasFieldError) return null;

  return (
    <FormHelperText sx={{ color: 'warning.main' }}>
      {t('reservation.returnDateDifferentThanAppointmentWarning')}
    </FormHelperText>
  );
}
